
import AppContent from '@components/new-styleguide/AppContent.vue';
import AppHeader from "@components/new-styleguide/AppHeader.vue";
import AppPage from '@components/new-styleguide/AppPage.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'NoMembershipPage',
  components: {
    AppHeader,
    AppContent,
    AppPage
  }
})
export default class NoMembershipPage extends Vue {
  @Prop({ default: false })
  private teaserWidget: boolean;
}

